
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'smoke_free': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 21',
    data: '<path pid="0" d="M0 4l6.99 7H0v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H20v3h-1.5zM16 11h1.5v3H16zm.85-8.12a3.324 3.324 0 0 0 1-2.38h-1.5a1.852 1.852 0 0 1-1.85 1.85v1.5a4.021 4.021 0 0 1 4 4.07V10H20V7.92a5.558 5.558 0 0 0-3.15-5.04zM12.5 6.7h1.53A1.927 1.927 0 0 1 16 8.75V10h1.5V8.41a3.319 3.319 0 0 0-3.47-3.16H12.5a1.986 1.986 0 0 1-1.85-2A1.769 1.769 0 0 1 12.5 1.5V0a3.35 3.35 0 0 0-3.35 3.35A3.35 3.35 0 0 0 12.5 6.7zm2.5 7.23V11h-2.93z" _fill="#d9d9d9" fill-rule="evenodd"/>'
  }
})
